import React from 'react';
import '../styles/projects.css';

interface Site {
  name: string;
  url: string;
  domain: string;
  description: string;
  icon: string;
}

// Edit this list to add / change sites.
const sites: Site[] = [
  {
    name: 'Sovereignty Audit',
    url: 'https://www.sovereigntyaudit.eu',
    domain: 'sovereigntyaudit.eu',
    description:
      'A rigorous, AI-powered assessment across 8 critical domains and 264 questions — know your organization’s digital sovereignty posture.',
    icon: 'fa-shield-halved',
  },
  {
    name: 'Estimate Events',
    url: 'https://www.estimate.events',
    domain: 'estimate.events',
    description:
      'Revenue forecasting for event organizers — run the numbers on your conference or meetup before you sign the contracts.',
    icon: 'fa-chart-line',
  },
  {
    name: 'Decompose',
    url: 'https://www.decompose.run',
    domain: 'decompose.run',
    description:
      'A Docker Compose topology visualiser that turns your compose files into interactive diagrams of services, networks and volumes.',
    icon: 'fa-diagram-project',
  },
  {
    name: 'CI/CD Run',
    url: 'https://www.cicd.run',
    domain: 'cicd.run',
    description:
      'A blueprint for designing CI/CD at enterprise scale — the bloodstream of organizations practising DevOps and Value Stream Management.',
    icon: 'fa-infinity',
  },
  {
    name: 'No Thank You',
    url: 'https://www.nothankyou.fyi',
    domain: 'nothankyou.fyi',
    description:
      'Your last slide is your final chance to make an impact — end your presentation with a call to action, not a “thank you” slide.',
    icon: 'fa-person-chalkboard',
  },
];

const Projects: React.FC = () => {
  return (
    <div className="page projects">
      <div className="container">
        <h1>Projects</h1>
        <p className="intro">
          A collection of sites and tools I build and maintain. Pick one to explore.
        </p>

        <section className="projects-section">
          <div className="projects-grid">
            {sites.map((site) => (
              <a
                key={site.domain}
                className="project-card"
                href={site.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="project-icon">
                  <i className={`fa-solid ${site.icon}`}></i>
                </div>
                <h3>{site.name}</h3>
                <p>{site.description}</p>
                <span className="project-link">
                  {site.domain}
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>
                </span>
              </a>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default Projects;
